import { render, staticRenderFns } from "./result_choose.vue?vue&type=template&id=54479c88&scoped=true&"
import script from "./result_choose.vue?vue&type=script&lang=js&"
export * from "./result_choose.vue?vue&type=script&lang=js&"
import style0 from "./result_choose.vue?vue&type=style&index=0&id=54479c88&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54479c88",
  null
  
)

export default component.exports